import PortableTextPlus from "@/components/portable-text-plus";
import SegmentContainer from "@/components/segments/segment-container";
import CallToActionButton from "@/components/call-to-action-button";
import classNames from "classnames";

export default function StandardSingleBlock({ segment, ...props }) {
  const negativeMarginClasses = {
    none: "",
    "x-small": "-mt-6 sm:-mt-10",
    small: "-mt-10 sm:-mt-16",
    medium: "-mt-16 sm:-mt-24",
    large: "-mt-24 sm:-mt-32",
    "x-large": "-mt-32 sm:-mt-40",
  };

  return (
    <SegmentContainer
      className={props.paddingClasses}
      style={{ ...props.bgImageStyle, ...props.bgColorStyle }}
    >
      <div
        className={classNames(
          "leading-snug text-center sm:text-left space-y-8",
          props.widthClasses,
          negativeMarginClasses[segment.block.negativeTopOffset]
        )}
      >
        {segment.block.heading && (
          <div
            className={classNames(
              "leading-snug font-semibold",
              props.headingSizeClasses[segment.block.headingSize] ||
                "text-2xl md:text-3xl"
            )}
          >
            <PortableTextPlus value={segment.block.heading} />
          </div>
        )}
        {segment.block.content && (
          <div
            className={classNames(
              "md:text-lg space-y-6 prose-ul:space-y-2 prose max-w-full",
              "md:prose-li:text-lg prose-li:text-left",
              "prose-li:mx-4 lg:prose-li:mx-8 prose-strong:text-inherit",
              "marker:text-subheading-gray marker:text-sm"
            )}
          >
            <PortableTextPlus value={segment.block.content} />
          </div>
        )}
        {segment.block.callToActions && (
          <div className="pb-8 space-y-4">
            {segment.block.callToActions.map((callToAction) => (
              <CallToActionButton
                className="mr-4 w-64 lg:w-56"
                key={callToAction._key}
                href={callToAction.url}
                {...callToAction}
              >
                {callToAction.title}
              </CallToActionButton>
            ))}
          </div>
        )}
      </div>
    </SegmentContainer>
  );
}
